module.exports = __webpack_public_path__ + "static_wap/img/tuibao2.4d2d429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tuibao2.png
// module id = n92v
// module chunks = 1